import { GET_LIVE_SESSIONS, GET_NLEARN3_LIVECLASS_PACKAGES, GET_PROJECTS_LIST, GET_VENDORS } from "utils/graphql/services/live-classes/queries";
import { utcToIst } from "utils/time-util/utcIstTime";
import * as Yup from "yup";

export const table = {
    primaryData: [
        {
            title: "ID",
            value: "id",
            type: "configue",

        },
        {
            title:"Entity Name",
            value:"entityName",
            type:"configue"
        },
        {
            title:"Entity Type",
            value:"entityType",
            type:"configue"
        },
        {
            title:"Entity Value",
            value:"entityValue",
            type:"configue"
        },
        {
            title: "Type",
            value:"type",
            type:"configue"
        },
        {
            title:"Basic Vendor Users",
            value:"vendorUser",
            type:"configue"
        },
        {
            title:"Observer Link",
            value:"scheduleCopyAction",
            type:"configue"
        }
    ],
    secondaryData: [
        {
            title: "Buffer Start Time",
            value: "bufferedStartTime",
            type: "configue",

        },
        {
            title: "Buffer End Time",
            value: "bufferedEndTime",
            type: "configue",
            
        },
        {
            title: "Actual Start Time",
            value: "actualStartTime",
            type: "configue",
            
        },
        {
            title: "Actual End Time",
            value: "actualEndTime",
            type: "configue",
            
        },
        {
            title: "Created At",
            value: "createdAt",
            type: "configue",
           
        },
        {
            title: "Updated At",
            value: "updatedAt",
            type: "configue",
            name: "updatedAt",
            
        },
        {
            title: "Created By",
            value: "createdByName",
            type: "configue",
        },
        {
            title: "Updated By",
            value: "updatedByName",
            type: "configue",
            name: "updatedByName"
        }
    ],
};

export type SessionAllocation = {
    id: string;
    projectId: string;
    liveSessionId: string;
    nlearn3LiveclassPackageId:string;
    vendorId: string;
    createdAt: string;
    updatedAt: string;
    createdById: string;
    updatedById: string;
    createdByName: string;
    updatedByName: string;
};

export const sessionAllocationInitialValues: SessionAllocation = {
    id: "",
    projectId: "",
    liveSessionId: "",
    nlearn3LiveclassPackageId:"",
    vendorId: "",
    createdAt: "",
    updatedAt: "",
    createdById: "",
    updatedById: "",
    createdByName: "",
    updatedByName: "",
};

export const sessionAllocationMandatoryFields = [];

export const sessionAllocationValidationSchema = Yup.object().shape({
    
});

export const sessionAllocationProperties = [
   
    {
        id: "liveSessionId",
        type: "single-select-search",
        label: "Live Session",
        // list: "live_sessions_gq",
        keyValue: { label: "name", value: "id" },
        query: GET_LIVE_SESSIONS,
        gqlKey: "getLiveSessions",
        dataKey: "liveSessions",
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
         id: "liveclassPackageId",
         type: "single-select-search",
         label: "Nl3 Liveclass Package",
        //  list: "nl3_liveclass_packages_gq",
         keyValue: { label: "name", value: "id" },
         query: GET_NLEARN3_LIVECLASS_PACKAGES,
         gqlKey: "getNlearn3LiveclassPackages",
         dataKey: "nlearn3LiveclassPackages",
         searchFieldKey: "searchName",
         className: "name-styles",
         breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
         required: false,
       },
    {
        id: "vendorId",
        type: "single-select-search",
        label: "Vendor *",
        // list: "vendors_gq",
        keyValue: { label: "name", value: "id" },
        query: GET_VENDORS,
        gqlKey: "getVendors",
        dataKey: "vendors",
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },

];

export function hasAtLeastOneValue(obj: any, keys: any[]) {
    return keys.some((key) => {
        const value = obj[key];
        return (
            value !== "" &&
            value !== null &&
            value !== undefined &&
            !(Array.isArray(value) && value.length === 0) &&
            !(Array.isArray(value) && value.every(v => v === null))
        );
    });
}
